// Sprint-V25 Issue L (Sa 12.09.2026) — StickyBottomCTA
// Erscheint auf Mobile erst, sobald der Hero komplett aus dem Viewport
// gescrollt ist (IntersectionObserver auf Hero-Element). Bei Scroll zurueck
// in den Hero verschwindet er wieder.
// - safe-area-inset-bottom aware
// - background-blur fuer Lesbarkeit ueber Content
// - full-width minus 32px Padding je Seite

import React, { useEffect, useState } from "react";
import { CTA_LABEL } from "@/data/landingHookCopy";

const HERO_TESTID = "lp-hero-section";
// Sprint-V25 Issue L Hotfix (Sa 12.09.2026 10:00) — Sticky-CTA soll auch
// ausgeblendet werden, wenn der User im inline QuickTest ist bzw. sein
// Ergebnis sieht. Sonst irritiert der „Test starten"-Button, weil der Test
// direkt darueber gerade laeuft/beendet ist.
const QUICKTEST_ID = "lp-quicktest";

export default function StickyBottomCTA({ onCtaClick }) {
  // Sichtbar nur wenn WEDER Hero NOCH QuickTest im Viewport sind.
  const [heroVisible, setHeroVisible] = useState(null);
  const [quicktestVisible, setQuicktestVisible] = useState(null);

  useEffect(() => {
    if (typeof window === "undefined" || typeof IntersectionObserver === "undefined") {
      setHeroVisible(false);
      setQuicktestVisible(false);
      return undefined;
    }
    const hero = document.querySelector(`[data-testid="${HERO_TESTID}"]`);
    const quicktest = document.getElementById(QUICKTEST_ID);

    if (!hero && !quicktest) {
      setHeroVisible(false);
      setQuicktestVisible(false);
      return undefined;
    }

    const heroObs = hero
      ? new IntersectionObserver(
          (entries) => entries.forEach((e) => setHeroVisible(e.isIntersecting)),
          { threshold: 0.1 },
        )
      : null;
    const qtObs = quicktest
      ? new IntersectionObserver(
          (entries) => entries.forEach((e) => setQuicktestVisible(e.isIntersecting)),
          { threshold: 0.05 },
        )
      : null;
    if (hero && heroObs) heroObs.observe(hero);
    if (quicktest && qtObs) qtObs.observe(quicktest);
    return () => {
      heroObs?.disconnect();
      qtObs?.disconnect();
    };
  }, []);

  const show = heroVisible === false && quicktestVisible === false;

  return (
    <div
      data-testid="lp-sticky-cta"
      data-visible={show ? "true" : "false"}
      aria-hidden={!show}
      className={
        "sm:hidden fixed left-0 right-0 z-40 transition-all duration-200 " +
        (show
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 translate-y-4 pointer-events-none")
      }
      style={{
        bottom: "calc(env(safe-area-inset-bottom, 0px))",
      }}
    >
      <div className="backdrop-blur-md bg-white/85 dark:bg-slate-900/85 border-t border-slate-200 dark:border-slate-700 px-4 pt-3 pb-3">
        <button
          type="button"
          data-testid="lp-sticky-cta-btn"
          onClick={() => onCtaClick && onCtaClick("offer")}
          className="w-full min-h-[48px] px-6 rounded-xl font-semibold text-white bg-[var(--fts-accent,#DC2626)] hover:bg-[var(--fts-accent-hover,#B91C1C)] focus:outline-none focus-visible:ring-4 focus-visible:ring-red-200 dark:focus-visible:ring-red-900/40 transition-colors"
        >
          {CTA_LABEL}
        </button>
      </div>
    </div>
  );
}
